import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

import AppRoutes from './AppRoutes';

import defaultTheme from './styles/theme/theme';
import { UserProvider } from './context/UserState';
import { ProjectDataProvider } from './context/ProjectDataState';

import Header from './components/Header';
import Footer from './components/Footer';

const App = () => (
	<MuiThemeProvider theme={defaultTheme}>
		<ThemeProvider theme={defaultTheme}>
			<UserProvider>
				<ProjectDataProvider>
					<CssBaseline />
					<Header />
					<AppRoutes />
					<Footer />
				</ProjectDataProvider>
			</UserProvider>
		</ThemeProvider>
	</MuiThemeProvider>
);

export default App;
